import { COMPLAINT_DETAIL_RESET } from '../actions/complaint-detail-reset';
// import { ADD_FEEDBACK_FULFILLED } from '../actions/add-complaint-feedback';
 const ADD_FEEDBACK_FULFILLED = 'add-feedback_FULFILLED';

const INITIAL_STATE = {};

export default function complaintDetail(state = INITIAL_STATE, { type, payload }) {

  switch (type) {

    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'complaintDetail') {
        console.log('abc ====>', payload);
        return {
          ...payload.response.data.data,
        };
      }
      return state;
    }

    case ADD_FEEDBACK_FULFILLED: {
      if (payload) {
        return {
          ...state,
          ...payload.data,
        };
      }
      return state;
    }

    case COMPLAINT_DETAIL_RESET: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
}
